import {
  ButtonType,
  ButtonWidget,
  InteractionState
} from '@tableau/widgets';
import React from 'react';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { Messages } from '../../../codegen/Localize';
import { SpaceHeaderStyles } from './SpaceHeaderStyles';

const ICON_PATH = imgPath('data_prep_info.svg');
const ACTIVE_ICON_PATH = imgPath('data_prep_info_active.svg');

const getDetailButtonContent = (state: InteractionState): JSX.Element => {
  const showActiveIcon = state.hover || state.active || state.focus;
  return (
    <img
      className={SpaceHeaderStyles.HeaderButtonImage}
      src={showActiveIcon ? ACTIVE_ICON_PATH : ICON_PATH}
      alt=""
    />
  );
};

export interface DetailButtonProps {
  readonly testId: string;
  readonly onClick: () => void;
}

export function DetailButton(props: DetailButtonProps) {
  return (
    <ButtonWidget
      buttonType={ButtonType.LowEmphasis}
      getContent={getDetailButtonContent}
      title={Messages.details()}
      testId={`${props.testId}-detail-button`}
      handleClick={props.onClick}
      style={SpaceHeaderStyles.IconButtonStyleOverrides}
    />
  );
}
